/**
 * Bootstrap accordion component autoplay function with binded content sync
 */

export default (() => {
  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-autoplay')

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    accordions.forEach((accordion) => {
      const accordionItems = accordion.querySelectorAll('.accordion-collapse')
      const accordionButtons = accordion.querySelectorAll('.accordion-button')
      let currentIndex = 0

      const intervalTime = parseInt(accordion.dataset.bsAutoplaySpeed) || 3000
      let autoplayInterval
      let progressInterval

      // Reset all progress bars
      function resetProgressBars() {
        const progressBars = accordion.querySelectorAll('.accordion-progress')
        progressBars.forEach((bar) => {
          bar.style.width = '0%'
        })
      }

      // Dynamically create progress bars
      function createProgressBars() {
        accordionItems.forEach((item) => {
          const progressBar = document.createElement('div')
          progressBar.classList.add('accordion-progress')
          progressBar.style.width = '0%'
          item.appendChild(progressBar)
        })
      }

      // Start the progress bar animation
      function startProgressBar(index) {
        let progress = 0
        const increment = 100 / (intervalTime / 100)
        const progressBar = accordionItems[index].querySelector(
          '.accordion-progress'
        )

        clearInterval(progressInterval)

        progressInterval = setInterval(() => {
          progress += increment
          if (progress >= 100) {
            progress = 100
            clearInterval(progressInterval)
          }
          progressBar.style.width = `${progress}%`
        }, 100)
      }

      // Show the next accordion item
      function showNextAccordion() {
        /* eslint-disable no-undef */
        const currentAccordion = new bootstrap.Collapse(
          accordionItems[currentIndex],
          {
            toggle: false,
          }
        )
        currentAccordion.hide()
        /* eslint-enable no-undef */

        resetProgressBars()

        currentIndex = (currentIndex + 1) % accordionItems.length

        /* eslint-disable no-undef */
        const nextAccordion = new bootstrap.Collapse(
          accordionItems[currentIndex],
          {
            toggle: false,
          }
        )
        nextAccordion.show()
        /* eslint-enable no-undef */

        startProgressBar(currentIndex)
        switchContent(currentIndex) // Sync binded content
      }

      // Start autoplay
      function startAutoplay() {
        stopAutoplay()
        autoplayInterval = setInterval(showNextAccordion, intervalTime)
        startProgressBar(currentIndex)
        switchContent(currentIndex)
      }

      // Stop autoplay
      function stopAutoplay() {
        clearInterval(autoplayInterval)
        clearInterval(progressInterval)
      }

      // Sync binded content block
      function switchContent(index) {
        const bindedContent = document.querySelector('.binded-content')
        if (!bindedContent) return

        const bindedItems = bindedContent.querySelectorAll('.binded-item')
        if (!bindedItems.length || !bindedItems[index]) return

        bindedItems.forEach((item) => item.classList.remove('active'))
        bindedItems[index].classList.add('active')
      }

      // Handle manual interaction
      accordionButtons.forEach((button, index) => {
        button.addEventListener('click', function () {
          stopAutoplay()
          currentIndex = index
          resetProgressBars()
          startProgressBar(currentIndex)
          switchContent(currentIndex)
          startAutoplay()
        })
      })

      createProgressBars()

      // Observe visibility before starting autoplay
      const accordionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startAutoplay()
          } else {
            stopAutoplay()
          }
        })
      }, observerOptions)

      accordionObserver.observe(accordion)
    })
  })
})()
